import './Activitycard.css';
import {
  Box,
  Button,
  Stack,
  Typography,
  useTheme,
  IconButton,
  Tooltip,
  TooltipProps,
  tooltipClasses,
  Paper

} from "@mui/material";
import { styled } from '@mui/material/styles';

import ClockIcon from '../../../static/svgs/ClockIcon.svg'
import ActivityBulb from '../../../static/svgs/ActivityBulb.svg'
import TaskContinueIcon from '../../../static/svgs/TaskContinueIcon.svg'
import { ReactComponent as FutureNavBadge } from '../../../static/svgs/FutureNavBadge.svg'
import { ReactComponent as ApprizeIcon } from '../../../static/svgs/ApprizeIcon.svg'
import LockedButtons from "static/svgs/LockedButtons.svg";
import { Module, ModuleStatuses } from "services/assessmentService";
import { useSelector } from "react-redux";
import CustomTask from "../CustomTask";
import { useLocation } from "react-router-dom";

interface BootstrapTooltipProps extends TooltipProps {
  customWidth?: string;
}

type ActivityCardProps = {
  module: Module;
  isNextActivity?: boolean;
  index?: number;
};
const ActivityCard = ({
  module,
  isNextActivity = false,
  index,
}: ActivityCardProps) => {
  const location = useLocation();
  const theme = useTheme();
  const BootstrapTooltip = styled(({ className, ...props }: BootstrapTooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ customWidth, theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: 'rgba(0, 82, 210, 1)',
      marginbottom: '2px'
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: 'rgba(0, 82, 210, 1)',
      color: 'rgba(255, 255, 255, 1)',
      borderRadius: "6px",
      fontFamily: "Open Sans",
      fontSize: "13px",
      width: customWidth || "97px",
      height: '34px',
      fontWeight: "600",
      lineHeight: "22px",
      textAlign: 'center'
    },
  }));
  const moduleStatus = (module?.status as any)?.status;
  const isLocked = isNextActivity;
  const { id, role, schoolName } = useSelector((state: any) => state.account);
  let { user, sub, name } = location.state || {};
  user = sessionStorage.getItem("userId") || user;
  sub = sessionStorage.getItem("userSub") || sub;
  name = sessionStorage.getItem("userName") || name;
  let userId = user ? user : id;

  const getLaunchURL = (module: Module, index: number = 0) => {
    try {
      const isEducator = role === "ROLE_EDUCATOR";
      const baseParams = `&s=${btoa(schoolName)}`;
      const baseEdgeParams = `?s=${btoa(schoolName)}`;
      const roleParam = `&r=${btoa(isEducator ? "educator" : "learner")}`;
      const fullEdgeParam = `${baseEdgeParams}&sid=${btoa(sub)}${roleParam}`
      const fullParams = `${baseParams}&sid=${btoa(sub)}${roleParam}`
      if (
        moduleStatus === ModuleStatuses.COMPLETED &&
        module.launchURL &&
        module.launchURL.includes("?to=")
      ) {

        if (module.type === "assess") {
          const toIndex = module.launchURL.indexOf("?to=");
          const toStrB64 = module.launchURL.substring(toIndex + 4);
          const decodedString = atob(toStrB64);
          const newRedirectTo = decodedString.replace(
            "/intro",
            "/insights/skills-report"
          );
          const encodedString = btoa(newRedirectTo);
          const returnUrl = module.launchURL.substring(0, toIndex + 4) + encodedString;
          if (isEducator) {
            return `${returnUrl}${fullParams}`;
          }
          else {
            return `${returnUrl}${baseParams}`;
          }
        }

        if (module.type === "apprize") {
          if (isEducator) {
            return `${module.insightsURL}${fullParams}`;
          }
          else {
            return `${module.insightsURL}${baseParams}`;
          }
        }

      }
      if (module.type == 'edge') {
        if (isEducator) {
          return `${module.launchURL}${fullEdgeParam}`;
        }
        else {
          return `${module.launchURL}${baseEdgeParams}`;
        }
      }
      if (module.type == 'schooljoy') {
          return `${module.launchURL}`;
      }
      return `${module.launchURL}${baseParams}`;
    }
    catch (error) {
      return `${module.launchURL}&s=${btoa(schoolName)}`;
    }
  };
  const targetWindow =
    module.type === "assess" ? 'launch_assessment' : module.type === "edge" ? 'launch_edge' : module.type === "apprize" ? 'launch_apprize' : ""

  const pascalToWords = (str: any) => {
    if (str == 'careerInterestProfiler') {
      str = "career Interest Profiler"
    }
    if (str == 'criticalThinking') {
      str = 'critical Thinking'
    }
    if(module.type === "schooljoy"){
     return str;
    }
    return str.toLowerCase().split(" ").map((w: any) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
  };
  const sortedActivities = module?.activities != undefined && module?.activities.sort((a: any, b: any) => a.sequence - b.sequence);
  const getButton = () => {
    if (role === "ROLE_EDUCATOR") {
      return <img className='lockImage' src={LockedButtons} />
    }
    else if (moduleStatus === ModuleStatuses.IN_PROGRESS) {
      return (<Button variant="outlined" className="cardButtonStartContinue"
        onClick={() => window.open(getLaunchURL(module, index), targetWindow)}>
        Continue
        <img style={{ marginLeft: '20px' }} src={TaskContinueIcon} alt="" />
      </Button>)
    }
    else {
      return <Button variant="outlined" className="cardButtonStartContinue"
        onClick={() => window.open(getLaunchURL(module, index), targetWindow)}>
        Start
        <img style={{ marginLeft: '20px' }} src={TaskContinueIcon} alt="" />
      </Button>
    }
  }

  return (
    <>
      <Paper sx={{ borderRadius: '8px', fontFamily: 'Open Sans' }}>
        <Box className='myBox'>
          {index != undefined && module.type === "edge" &&
            <BootstrapTooltip title='Futurenav™' placement="right-start" slotProps={{
              popper: {
                modifiers: [{
                  name: 'offset', options: { offset: [0, -12] }
                }],
              }
            }}>
              <IconButton
                sx={{ position: 'absolute', mb: '0px', ml: '0px' }}>
                <FutureNavBadge />
              </IconButton>
            </BootstrapTooltip>}
          {index != undefined && module.type === "apprize" &&
            <BootstrapTooltip title='Apprize™' placement="right-start" slotProps={{
              popper: {
                modifiers: [{
                  name: 'offset', options: { offset: [0, -12] }
                }],
              }
            }}>
              <IconButton
                sx={{ position: 'absolute', mb: '0px', ml: '0px' }}>
                <ApprizeIcon />
              </IconButton>
            </BootstrapTooltip>}

          <Box className='cardTimeBox' >
            <img height={'15px'} width={'15px'} style={{ marginRight: '3px', marginTop: '0px' }} src={ClockIcon} />{module.duration / 60} min
          </Box>
          <Box
            sx={{
              height: '124px',
              width: '208px',
              borderRadius: '4px',
              backgroundImage: `url(${module.imageUrl})`,
              backgroundSize: '100% 100%',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          />

          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography sx={{ fontWeight: 700, fontSize: '16px', mt: '8px' }}>
              {module.name}
            </Typography>
            <Box sx={{ display: 'flex' }}>
              {module?.skills.map((skill: any, index: number) => (
                <Typography sx={{ fontWeight: 400, fontSize: '12px', }}>
                  {pascalToWords(skill.skillId)}{index < module.skills.length - 1 ? ',\u00A0' : ''}
                </Typography>
              ))}
            </Box>

            {module?.activities != undefined && module?.activities?.length > 0 && <Typography sx={{ gap: '8px', mt: '15px', display: 'flex', fontWeight: 600, fontSize: '12px' }}>
              Tasks: <CustomTask activities={module && sortedActivities} status={module && module.status} />
            </Typography>}
            {moduleStatus === ModuleStatuses.COMPLETED ?
              <Button variant="outlined" className="cardButtonViewInsights"
                onClick={() => window.open(getLaunchURL(module, index), module.type === "assess" ? 'launch_assessment' : module.type === "edge" ? 'launch_edge' : module.type === "apprize" ? 'launch_apprize' : "")}  >
                View Insights
                <img style={{ marginLeft: '8px' }} src={ActivityBulb} alt="" />
              </Button> :
              getButton()
            }
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default ActivityCard;
